import React, {useEffect, useRef, useState} from 'react';
import {createOtpLoginStep3} from '../../../../utilities/authentication/authenticationSlice';
import {connect} from 'react-redux';
import {loginStep} from '../Assets/variables';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import TextInput from '../../../Shared/TextInput/TextInput';
import Config from '../../../../Config';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import '../OTPLoginBlock.scss';
import {report, getReportParams} from '../../../../middleware/report';
import Image from '../../../Shared/Image/image';
import {LogoHelper, LogoType} from 'app/utilities/LogoHelper/helper';
import EnterIdPartial from '../Assets/enterIdPartial';
const IdValidationPopup = (props) => {
  const mainLogo = LogoHelper.getLogo(LogoType.MainLogo);
  const [id, setId] = useState(''); //ID STATE
  const [errorInForm, setErrorForm] = useState(null); //ERROR STATE
  const [code, setCode] = useState(''); //CODE STATE
  const [mode, setMode] = useState(loginStep.ID); //MODE STATE
  const [isPassportInsert, setPassportInsert] = useState(false);

  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'NEW_OTP';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = 'Entered Id Completion Popup';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Entered Id Completion Popup';
    reportParams.subscriber = props.authentication.loginData?.userDetails?.contactNumber;

    report(reportParams);
  }, []);

  const modeSelect = (val) => {
    props.hideAppLoader();
    setMode(val);
  };

  const goToStep = async () => {
    let stepIsCorrect = await props.createOtpLoginStep3({
      phoneNumber: props.authentication.loginData.userDetails.contactNumber,
      idNumber: id,
      scope: 'PRIVATE_WEBSITE',
      code: code,
    });
    if (!isMounted.current) return;

    if (!stepIsCorrect.payload) {
      props.hideAppLoader();
      switch (mode) {
        case loginStep.ID:
          setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
          break;
        case loginStep.CODE:
          setErrorForm('יש טעות בקוד, שננסה שוב?');
          break;
      }
    } else {
      if (stepIsCorrect.payload.isSuccess) {
        setErrorForm(null);
        props.hideAppLoader();
        if (stepIsCorrect.payload.needsCode) {
          modeSelect(loginStep.CODE);
        } else {
          props.closeModal();
        }
      } else {
        props.hideAppLoader();
        switch (mode) {
          case loginStep.ID:
            setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
            break;
          case loginStep.CODE:
            setErrorForm('יש טעות בקוד, שננסה שוב?');
            break;
        }
      }
    }
  };
  const changeIdType = (val) => {
    setPassportInsert(val);
    setId('');
  };
  //ID INSERTION
  const validateId = async () => {
    props.showAppLoader();
    const idPattern = /^\d{9}$/;
    const passportPattern = /^[A-Za-z0-9]{6,12}$/;
    if (id == '' || id == null) {
      setErrorForm(isPassportInsert ? 'רגע... אנחנו לא מזהים את המספר, שננסה שוב?' : 'רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
      props.hideAppLoader();
      return false;
    }

    if (!isPassportInsert && !idPattern.test(id)) {
      setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
      props.hideAppLoader();
      return false;
    } else {
      if (isPassportInsert && !passportPattern.test(id)) {
        setErrorForm('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
        props.hideAppLoader();
        return false;
      } else {
        await goToStep();
      }
    }
  };
  const idMode = () => {
    return (
      <form
        action='#'
        onSubmit={async (e) => {
          e.preventDefault();
          await validateId();
        }}>
        <Image src={mainLogo} alt='main logo' />
        <h4 className='heading'>ת.ז ומתקדמים</h4>
        <EnterIdPartial
          onChangeType={changeIdType}
          errorInForm={errorInForm}
          onChangeText={(e) => {
            const numberRegex = /^\d+$/;
            const passportRegex = /^[A-Za-z0-9]{0,12}$/;

            if (
              (!isPassportInsert && (numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9) ||
              (isPassportInsert && (e.target.value === '' || passportRegex.test(e.target.value)))
            ) {
              setId(e.target.value);
              setErrorForm(null);
              return true;
            }
            return false;
          }}
        />
        {/* <TextInput
          placeholder={'מספר ת.ז / ח.פ'}
          value={id}
          type="text"
          inputMode="numeric"
          maxLength={'9'}
          error={errorInForm}
          onChange={(e) => {
            const numberRegex = /^\d+$/;
            if (numberRegex.test(e.target.value) || e.target.value === '') {
              setId(e.target.value);
              setErrorForm(null);
            }
          }}
        /> */}
        <div className='footer'>
          <BtnSubmit text={'המשך'} className='continueButton' />
        </div>
      </form>
    );
  };
  //CODE INSERTION
  const validateCode = async () => {
    props.showAppLoader();
    if (code == '' || code == null) {
      setErrorForm('אנא הזן קוד זיהוי');
      props.hideAppLoader();
      return false;
    } else {
      await goToStep();
    }
  };
  const codeMode = () => {
    return (
      <form
        action='#'
        onSubmit={async (e) => {
          e.preventDefault();
          await validateCode();
        }}>
        <Image src={mainLogo} alt='main logo' />
        <h4 className='heading'>מה קוד הזיהוי שהגדרת?</h4>
        <TextInput
          placeholder={'קוד זיהוי'}
          value={code}
          error={errorInForm}
          onChange={(e) => {
            setCode(e.target.value);
            setErrorForm(null);
          }}
        />
        <div className='footer'>
          <BtnSubmit text={'המשך'} className='continueButton' />
        </div>
      </form>
    );
  };
  //TERMS AND CONDITIONS SCREEN

  const screenToShow = () => {
    switch (mode) {
      case loginStep.ID:
        return idMode();
      case loginStep.CODE:
        return codeMode();
    }
  };
  return (
    <div className='idValidationPopup_OTPLogin OTPLoginBlock'>
      <div className='screenContainer'>{screenToShow()}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  createOtpLoginStep3,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(IdValidationPopup);
